import { useNavInputs } from 'app/hooks/useNavInputs'
import { usePermissionFilteredSidebar } from 'app/hooks/usePermissionFilteredSidebar'
import type { UserJson } from 'app/types/entities'
import { getSideBarItems } from 'lib/sidebarItems'

/**
 * The permission-filtered navigation tree, exactly as SideBarV2 renders it. Shared with the
 * global search palette so the two never disagree about what a user can reach.
 */
export function useNavItems(user: UserJson) {
  const { input, locationCount, refetchCustomPages, refetchPipelines, refreshSidebarCounts } = useNavInputs(user)
  const { items: navItems, isLoading: permissionsLoading } = usePermissionFilteredSidebar(getSideBarItems(input), user)

  return {
    navItems,
    permissionsLoading,
    products: input.products,
    staffV2Enabled: input.staffV2Enabled,
    isOrgUser: input.isOrgUser,
    customPages: input.customPages,
    locationCount,
    pipelines: input.pipelines,
    refetchCustomPages,
    refetchPipelines,
    refreshSidebarCounts,
  }
}
